import { useState } from "react";
import { Link } from "react-router-dom";

export function Footer() {
  const [email, setEmail] = useState("");
  const cols = [
    { title: "Shop", links: [["Home", "/"], ["All Products", "/shop"], ["Matching Sets", "/shop?collection=Matching%20Sets"]] },
    { title: "Explore", links: [["About Us", "/about"], ["FAQ", "/faq"], ["Contact", "/contact"]] },
  ];
  return (
    <footer className="bg-charcoal text-bone" data-testid="site-footer">
      <div className="container-luxe py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <img src="/brand/sv-seal.png" alt="SV Athletic Wear" className="h-28 w-auto object-contain" />
          <p className="mt-6 font-serif text-2xl font-light text-bone/70 leading-snug max-w-sm">Wear Confidence.</p>
          <form onSubmit={(e) => e.preventDefault()} className="mt-8 max-w-sm" data-testid="footer-newsletter-form">
            <label className="overline text-[10px] text-bone/60">Newsletter launching with our full collection</label>
            <div className="mt-3 flex border-b border-bone/30">
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" disabled placeholder="Email address"
                data-testid="footer-newsletter-input"
                className="flex-1 bg-transparent py-3 text-sm outline-none placeholder:text-bone/40 disabled:opacity-60 disabled:cursor-not-allowed" />
              <button type="submit" disabled data-testid="footer-newsletter-submit" className="overline text-[10px] text-gold disabled:opacity-70 disabled:cursor-not-allowed">Coming Soon</button>
            </div>
          </form>
        </div>
        {cols.map((c) => (
          <div key={c.title} className="lg:col-span-2">
            <h4 className="overline text-[10px] text-bone/60 mb-5">{c.title}</h4>
            <ul className="space-y-3">
              {c.links.map(([l, to]) => (
                <li key={l}><Link to={to} className="text-sm text-bone/80 hover:text-gold transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-bone/10">
        <div className="container-luxe py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-bone/50 text-xs">
          <span>© {new Date().getFullYear()} SV Athletic Wear. All rights reserved.</span>
          <span className="overline text-[10px]">Move With Confidence.</span>
        </div>
      </div>
    </footer>
  );
}
